import api from './api'
import queryString from 'querystring'

const companyBasePath = '/api/v1/company'

export async function getCompany(getQueryParams) {
  const resp = await api.get(`${companyBasePath}?${queryString.stringify(getQueryParams)}`)
  return resp.data
}

export async function searchCompanies(searchQueryParams) {
  const resp = await api.get(`${companyBasePath}/search?${queryString.stringify(searchQueryParams)}`)
  return resp.data
}

export async function getKkvResult(searchQueryParams) {
  const resp = await api.get(`${companyBasePath}/search?${queryString.stringify(searchQueryParams)}`)
  return resp.data
}

export async function getCompanyFieldFormTemplates() {
  const resp = await api.get(`${companyBasePath}/company-form-fields`)
  return resp.data
}
